import React, { Component } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import Text from '../textComponent';
import Colors from '../../config/Colors';

// https://codesandbox.io/s/l29rokm9rm

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

const range = (from, to, step = 1) => {
    let i = from;
    const range = [];

    while (i <= to) {
        range.push(i);
        i += step;
    }

    return range;
};

class Pagination extends Component {
    constructor(props) {
        super(props);
        const {
            totalRecords = null,
            pageLimit = 50,
            pageNeighbours = 0,
            currentPage = 1
        } = props;

        this.totalRecords = typeof totalRecords === 'number' ? totalRecords : 0;

        this.pageNeighbours =
            typeof pageNeighbours === 'number'
                ? Math.max(0, Math.min(pageNeighbours, 2))
                : 0;

        this.totalPages = Math.ceil(this.totalRecords / pageLimit);

        this.state = { currentPage };
    }

    goToPage = (page) => {
        const currentPage = Math.max(0, Math.min(page, this.totalPages));

        this.setState({ currentPage }, () =>
            this.props.onPageChange(currentPage)
        );
    };

    movePage = (page) => {
        this.goToPage(page);
    };

    moveLeft = () => {
        this.goToPage(this.state.currentPage - this.pageNeighbours * 2 - 1);
    };

    moveRight = () => {
        this.goToPage(this.state.currentPage + this.pageNeighbours * 2 + 1);
    };

    fetchPageNumbers = () => {
        const totalPages = this.totalPages;
        const currentPage = this.state.currentPage;
        const pageNeighbours = this.pageNeighbours;

        const totalNumbers = this.pageNeighbours * 2 + 3;
        const totalBlocks = totalNumbers + 2;

        if (totalPages > totalBlocks) {
            let pages = [];

            const leftBound = currentPage - pageNeighbours;
            const rightBound = currentPage + pageNeighbours;
            const beforeLastPage = totalPages - 1;

            const startPage = leftBound > 2 ? leftBound : 2;
            const endPage =
                rightBound < beforeLastPage ? rightBound : beforeLastPage;

            pages = range(startPage, endPage);

            const pagesCount = pages.length;
            const singleSpillOffset = totalNumbers - pagesCount - 1;

            const leftSpill = startPage > 2;
            const rightSpill = endPage < beforeLastPage;

            const leftSpillPage = LEFT_PAGE;
            const rightSpillPage = RIGHT_PAGE;

            if (leftSpill && !rightSpill) {
                const extraPages = range(
                    startPage - singleSpillOffset,
                    startPage - 1
                );
                pages = [leftSpillPage, ...extraPages, ...pages];
            } else if (!leftSpill && rightSpill) {
                const extraPages = range(
                    endPage + 1,
                    endPage + singleSpillOffset
                );
                pages = [...pages, ...extraPages, rightSpillPage];
            } else if (leftSpill && rightSpill) {
                pages = [leftSpillPage, ...pages, rightSpillPage];
            }

            return [1, ...pages, totalPages];
        }

        return range(1, totalPages);
    };

    render() {
        if (!this.totalRecords) return null;

        if (this.totalPages === 1) return null;

        const { currentPage = 1 } = this.state,
            pages = this.fetchPageNumbers();

        return (
            <View style={[this.props.style, styles.container]}>
                <View style={styles.pagesContainer}>
                    {pages.map((page, index) => {
                        const isCurrentPage = currentPage === page,
                            isLeft = page === LEFT_PAGE,
                            isRight = page === RIGHT_PAGE;

                        return (
                            <View key={index}>
                                <TouchableOpacity
                                    onPress={() =>
                                        isLeft
                                            ? this.moveLeft()
                                            : isRight
                                              ? this.moveRight()
                                              : this.movePage(page)
                                    }
                                >
                                    <Text
                                        $bold={isCurrentPage ? 'true' : null}
                                        style={[
                                            styles.pageNumber,
                                            isCurrentPage
                                                ? styles.currentPage
                                                : null
                                        ]}
                                    >
                                        {isLeft ? '<' : isRight ? '>' : page}
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        );
                    })}
                </View>
            </View>
        );
    }
}

export default Pagination;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        height: 40,
        backgroundColor: Colors.white,
        alignItems: 'center',
        alignContent: 'center'
    },
    pagesContainer: {
        flexDirection: 'row',
        paddingVertical: 4
    },
    pageNumber: {
        width: 30,
        color: Colors.greyDark,
        fontSize: 22,
        marginHorizontal: 2,
        textAlign: 'center'
    },
    currentPage: {
        color: Colors.blue
    }
});
